import { createEvent } from '@cobuildlab/react-simple-state';
import { GenderType } from '../../shared/types';

export const OnGenderType = createEvent<GenderType[]>();
export const OnGenderTypeError = createEvent();
